// extracted by mini-css-extract-plugin
export default {"loader_line":"fallbackLoader_loader_line__UucEa","lineAnim":"fallbackLoader_lineAnim__6MCMp"};